import { useTranslation } from 'react-i18next';

import SearchIcon from '@/shared/assets/icons/search.svg?react';
import { Input } from '@/shared/ui/Input';

type LeaderboardSearchProps = {
  value: string;
  onChange: (value: string) => void;
};

export function LeaderboardSearch({ value, onChange }: LeaderboardSearchProps) {
  const { t } = useTranslation();

  return (
    <Input
      value={value}
      size="sm"
      onChange={onChange}
      placeholder={t('leaderboard.searchPlaceholder')}
      ariaLabel={t('leaderboard.searchPlaceholder')}
      leftAddon={<SearchIcon className="field__icon" />}
      rightAddon={
        value.trim().length > 0 ? (
          <button type="button" className="field__clear" onClick={() => onChange('')}>
            ✕
          </button>
        ) : undefined
      }
    />
  );
}
